var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 547,
    height: 194.109,
    preserveAspectRatio: "none",
    viewBox: "0 0 547 194.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grey-band",
    transform: "translate(-573.002 -88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    d: "M520.809,0H26.192A26.1,26.1,0,0,0,0,26.014v165.1c6.716-24.68,29.617-75.241,67.494-80.044s326.051-2,387.836,0c15.446.667,81.6,5,91.67-48.026V26.014A26.1,26.1,0,0,0,520.809,0Z",
    transform: "translate(573.002 91)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    d: "M494.9,0H.1A26.048,26.048,0,0,0-26,26V187c6.691-24.667,29.508-75.2,67.246-80s326.862-2,388.42,0c15.389.667,81.3,5,91.334-48V26A26.048,26.048,0,0,0,494.9,0Z",
    transform: "translate(599.002 88)",
    fill: "#e3e3e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverage);
export default __webpack_public_path__ + "static/media/average.816e7d4f4430f1646bf150416323ed1b.svg";
export { ForwardRef as ReactComponent };